
<div class="nsw-container-fluid">
    <app-banner></app-banner>
    <app-search [allBeachSites]="sites"></app-search>
    <div class="nsw-layout">
        <main class="nsw-layout__main" >
            <section class="nsw-section">                
                <app-maps-section 
                    [allBeachSites]="sites"
                    (updateSitePollutionForecast)="onUpdateSitePollutionForecast($event)"></app-maps-section>	                 
            </section>
            <section>
                <app-content-cards></app-content-cards>
            </section>
            <section class="nsw-section">
                <app-subscribe-section></app-subscribe-section>
            </section>            
        </main>
    </div>
</div>

